// =============================================================================
// FILE: equipmentService.js
// MODULE: PPE → Engineering → Equipment Master
// =============================================================================

import axiosClient from "../../../../../../api/axiosClient";


// -----------------------------------------------------------------------------
// LIST EQUIPMENT
// -----------------------------------------------------------------------------
export const getEquipmentList = async ({
  search = "",
  is_active = null,
  product_variant_id = null
} = {}) => {

  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }

  if (product_variant_id) {
    params.append(
      "product_variant_id",
      product_variant_id
    );
  }

  if (is_active !== null && is_active !== undefined) {
    params.append(
      "is_active",
      is_active
    );
  }

  const response = await axiosClient.get(
    `/api/ppe/masters/equipment/list?${params.toString()}`
  );

  return response.data;
};


// -----------------------------------------------------------------------------
// GET SINGLE EQUIPMENT
// -----------------------------------------------------------------------------
export const getEquipment = async (equipmentId) => {

  const response = await axiosClient.get(
    `/api/ppe/masters/equipment/${equipmentId}`
  );

  return response.data;
};


// -----------------------------------------------------------------------------
// CREATE EQUIPMENT
// -----------------------------------------------------------------------------
export const createEquipment = async (payload) => {

  const response = await axiosClient.post(
    `/api/ppe/masters/equipment`,
    payload
  );

  return response.data;
};


// -----------------------------------------------------------------------------
// UPDATE EQUIPMENT
// -----------------------------------------------------------------------------
export const updateEquipment = async (
  equipmentId,
  payload
) => {

  const response = await axiosClient.put(
    `/api/ppe/masters/equipment/${equipmentId}`,
    payload
  );

  return response.data;
};


// -----------------------------------------------------------------------------
// ACTIVATE / DEACTIVATE EQUIPMENT
// -----------------------------------------------------------------------------
export const updateEquipmentStatus = async (
  equipmentId,
  is_active
) => {

  const response = await axiosClient.patch(
    `/api/ppe/masters/equipment/status/${equipmentId}`,
    {
      is_active
    }
  );

  return response.data;
};